import type { RiskTier } from "@busright/data-contract";

// TS mirror of tokens.css for places that need color values in JS (chart series, canvas, ECharts
// option objects). Keep in sync with tokens.css — this is the JS-side source of truth.

export const COLORS = {
  surface0: "#0a0e1a",
  surface1: "#111726",
  surface2: "#1a2236",
  surface3: "#232d45",
  border: "#2c3650",
  borderStrong: "#3a4768",
  textPrimary: "#e8edf7",
  textSecondary: "#9aa7c2",
  textMuted: "#5f6e8c",
  accent: "#ffd200",
  accentHover: "#ffe04d",
} as const;

// RAG — health/risk ONLY.
export const RAG = {
  OK: "#22c55e",
  WARN: "#f59e0b",
  CRITICAL: "#ef4444",
} as const;

// Sequential neutral→brand ramp for non-health series.
export const SEQUENTIAL: readonly string[] = [
  "#2c3650",
  "#3d4a6e",
  "#5566a0",
  "#7d8fc7",
  "#b3a14a",
  "#ffd200",
] as const;

export const ragColor = (tier: RiskTier): string => RAG[tier];

// Pick `n` evenly-spaced colors from the sequential ramp for a categorical/non-health chart.
export const sequentialColors = (n: number): string[] => {
  if (n <= 1) {
    return [SEQUENTIAL[SEQUENTIAL.length - 1]];
  }
  const step = (SEQUENTIAL.length - 1) / (n - 1);
  return Array.from({ length: n }, (_, i) => SEQUENTIAL[Math.round(i * step)]);
};
